<div class="w-full max-w-8xl">
  <!-- Form -->
  <!-- Section -->
  <form [formGroup]="objectSettingsForm">
    <!-- Name -->
    <div class="flex">
      <mat-form-field class="flex-auto mx-auto">
        <mat-label class="text-black">Nom de l'espace</mat-label>
        <input 
          matInput 
          [formControlName]="'name'" 
          [enableByRole]="['admin', 'write']"
          [placeholder]="''"
           />
      </mat-form-field>
    </div>
    <!-- Description -->
    <div class="flex">
      <mat-form-field class="flex-auto mx-auto">
        <mat-label class="text-black">Description</mat-label>
        <textarea
          matInput
          [formControlName]="'description'"
          [enableByRole]="['admin', 'write']"
          [placeholder]="''"
          [rows]="3"></textarea>
      </mat-form-field>
    </div>
    <!-- Date -->
    <div class="sm:col-span-4 w-full flex flex-row gap-2">
      <mat-form-field
        color="accent"
        class="block text-sm w-full font-semibold leading-6 text-gray-900">
        <mat-label class="text-black">Date de début</mat-label>
        <input 
          matInput 
          formControlName="startDate" 
          [enableByRole]="['admin', 'write']"
          [matDatepicker]="picker1" />
        <mat-datepicker-toggle [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        color="accent"
        class="block text-sm w-full font-semibold leading-6 text-gray-900">
        <mat-label class="text-black">Date de fin</mat-label>
        <input 
          matInput 
          formControlName="endDate"
          [enableByRole]="['admin', 'write']"
          [matDatepicker]="picker2"  />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2 color="primary"></mat-datepicker>
      </mat-form-field>
    </div>
  </form>

  <!-- Project Appearance -->
  <div class="mt-1 mb-3 border-t"></div>
  <div class="flex flex-col gap-y-2">
    <div class="text-base font-medium text-black">Apparence</div>
    <form [formGroup]="projectAppearanceForm">
      <mat-radio-group
        formControlName="selectedOption"
        [enableByRole]="['admin', 'write']"
        class="flex flex-col"
        [color]="'primary'">
        <mat-radio-button value="logo">
          <span>Charger une image.</span>
        </mat-radio-button>
        <div
          class="flex flex-row justify-start gap-x-2 ml-10"
          [style.opacity]="
            projectAppearanceForm.get('selectedOption')?.value === 'logo'
              ? 1
              : 0.5
          ">
          <div
            class="relative w-10 h-10 overflow-hidden bg-zinc-300 rounded-full dark:bg-gray-600">
            <ng-container *ngIf="logo$ | async as logo; else defaultIcon">
              <img
                [src]="logo"
                alt="Project Background"
                class="w-10 h-10 rounded-full" />
            </ng-container>
            <ng-template #defaultIcon>
              <mat-icon
                class="text-gray-100 icon-size-10 px-1"
                [svgIcon]="'heroicons_solid:user'"></mat-icon>
            </ng-template>
          </div>
          <button
            [disabled]="
              projectAppearanceForm.get('selectedOption')?.value === 'colorIcon'
            "
            class="btn-secondary-hover px-2"
            (click)="fileInput.click()">
            <span>Charger</span>
            <span *ngIf="false"> Modifier </span>
          </button>
          <input
            style="display: none"
            type="file"
            #fileInput
            (change)="onFileSelected($event)" />
        </div>
        <mat-radio-button value="colorIcon">
          <span>Définir une couleur et une icône.</span>
        </mat-radio-button>
        <div
          class="w-160 h-30 bg-white rounded-md justify-start items-start inline-flex ml-10"
          [style.opacity]="
            projectAppearanceForm.get('selectedOption')?.value === 'colorIcon'
              ? 1
              : 0.5
          ">
          <div class="grid grid-cols-8 mt-4 p-3 gap-2">
            <div *ngFor="let color of colors">
              <button
                (click)="selectProperty('color', color)"
                [style.background-color]="color"
                [disabled]="
                  projectAppearanceForm.get('selectedOption')?.value === 'logo'
                "
                [ngClass]="{
                  'border-2 border-gray-600':
                    projectAppearanceForm.value.color === color
                }"
                class="rounded h-6 w-6"></button>
            </div>
          </div>
          <div
            class="border-r-2 border-gray-300 h-30 mx"
            aria-hidden="true"></div>
          <div class="grid grid-cols-10 py-1 gap-1.5">
            <div *ngFor="let icon of icons">
              <button
                [disabled]="
                  projectAppearanceForm.get('selectedOption')?.value === 'logo'
                ">
                <mat-icon
                  (click)="selectProperty('icon', icon)"
                  [svgIcon]="'heroicons_solid:' + icon"
                  [ngClass]="{
                    'bg-gray-200 p-1 rounded': projectAppearanceForm.value.icon === icon
                  }"
                  class="text-[#454F5F] rounded h-7 w-7">
                </mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-radio-group>
    </form>

    <!-- Deletion feature -->
    <div class="mt-3 mb-3 border-t"></div>
    <div class="flex flex-col" [enableByRole]="['admin']">
      <div  class="text-lg font-semibold">Supprimer l'espace.</div>
      <div class="mt-2">Cela supprimera l'espace de façon définitive.</div>
      <button
        class="mt-4 ml-1 w-32 text-base btn-danger-hover"
        (click)="deleteProject()"
        type="button">
        Supprimer l'espace
      </button>
    </div>
  </div>
  <!-- Actions -->
  <div class="flex items-center mt-2 justify-end">
    <button
      (click)="this._matDialogRef.close()"
      class="btn-tertiary"
      mat-dialog-close
      type="button">
      Annuler
    </button>
    <button 
      (click)="saveChanges()"
      [enableByRole]="['admin', 'write']"
      class="btn-primary-hover" 
      type="button">
      Enregistrer
    </button>
  </div>
</div>
